import { State, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserStateModel } from './user-state-model';
import { SkipTour, UpdateProfileCoverImage, UpdateUser } from './user-action';
import { PersonalInfoState } from '../../models/enums/peronsalInfoState';

@State<UserStateModel>({
  name:'user',
  defaults:{
   email:'',
   phoneNumber:'',
   firstName:'',
   lastName:'',
   id:'',
   role:[],
   isNewUser:false,
   profileImageUrl:'',
   profileImageFormat:'',
   personalInfoState: PersonalInfoState.StudentInfoPending,
   degreePreference: undefined
  }
})
@Injectable()
export class UserState{
  @Action(UpdateUser)
  updateUser(ctx:StateContext<UserStateModel>,action:UpdateUser):UserStateModel{
    const state = ctx.getState();
    ctx.setState({
      ...state,
      email:action.payload.email,
      phoneNumber:action.payload.phoneNumber,
      firstName:action.payload.firstName,
      lastName:action.payload.lastName,
      id:action.payload.id,
      role:action.payload.role || [],
      isNewUser: action.payload.isNewUser,
      profileImageUrl: action.payload.profileImageUrl,
      profileImageFormat: action.payload.profileImageFormat,
      personalInfoState: action.payload.personalInfoState,
      degreePreference: action.payload.degreePreference
    });
    return state;
  }
  @Action(UpdateProfileCoverImage)
  updateProfilCoverImage(ctx: StateContext<UserStateModel>, action:UpdateProfileCoverImage): UserStateModel{
    const state = ctx.getState();
    ctx.patchState({
      profileImageUrl: action.payload.profileImageUrl,
      profileImageFormat: action.payload.profileImageUrlFormat
    });
    return state;
  }
  @Action(SkipTour)
  skipTour(ctx: StateContext<UserStateModel>, action: SkipTour): UserStateModel{
    const state = ctx.getState();
    ctx.patchState({
      isNewUser: action.payload.isNewUser
    });
    return state;
  }

}
